<template>
  <div>
    <!-- page title for payment create -->
    <GlobalHeader title="Customer Advance" style="margin-top:-10px;" @redirectPage="redirectPage"></GlobalHeader>
    <!--Validatioon for customer advance -->
    <b-row class="mt-2 px-pad">
      <b-col xl="12" lg="12" md="12" xs="12" sm="12" class="px-0">
        <div class="container-fluid">
          <b-alert class="alert-transparent alert-danger" :show="duplicatecode">
            <p class="fw-semi-bold">{{ message }}</p>
          </b-alert>
          <b-alert class="alert-transparent alert-danger" :show="error_show && this.errors.any()">
            <button type="button" @click="error_show =!error_show" class="close">
              <span aria-hidden="true">&times;</span>
            </button>
            <div v-for="item in errors.items" :key="item.id" v-if="item.scope=='customer-adv-form'">
              <p class="fw-semi-bold">{{ item.msg }}</p>
            </div>
          </b-alert>
        </div>
      </b-col>
    </b-row>

    <b-form
      @submit.prevent="onSubmit('customer-adv-form')"
      id="invoice_form"
      data-vv-scope="customer-adv-form"
      class="mt-1"
      style="margin-left:3px;margin-right:3px;"
    >
      <div class="sales-bg pt-4 pb-4 mb-2 border-bottom-dot" style="background:#f7f7f7">
        <!--  customer input block -->
        <b-row>
          <b-col xl="10" lg="10" md="10" sm="10" xs="10" @click="removecustomer">
            <b-form-group>
              <div class="input-group">
                <vue-bootstrap-typeahead
                  v-if="page == 'create'"
                  id="customer_search"
                  class="customer_search"
                  v-model="cus_id"
                  :data="customers"
                  :serializer="customer => customer.label"
                  @hit="checkpos($event)"
                  placeholder="Type to search customer"
                  ref="cus_name_typeahead"
                  title="Enter first three characters of customer to search"
                />
                <input
                  v-else
                  type="text"
                  class="form-control input_customer_search"
                  v-model="cus_id"
                  readonly
                />
                <div class="input-group-append">
                  <b-dropdown
                    class="advance-search-option btn-radius-unset text-center"
                    size="sm"
                    variant="light"
                    :text="search_value"
                    style="height:32px;"
                  >
                    <b-dropdown-item
                      @click="search_column = 'cus_display_name',search_value='Customer Name'"
                    >Customer Name</b-dropdown-item>
                    <b-dropdown-item
                      @click="search_column = 'cus_ph_no_1',search_value='Phone Number'"
                    >Phone Number</b-dropdown-item>
                    <b-dropdown-item
                      @click="search_column = 'cus_legacy_id',search_value='Customer ID'"
                    >Customer ID</b-dropdown-item>
                    <b-dropdown-item
                      @click="search_column = 'cus_gst_no',search_value='Gst Number'"
                    >Gst Number</b-dropdown-item>
                    <b-dropdown-item
                      @click="search_column = 'cus_pan_no',search_value='PAN Number'"
                    >PAN Number</b-dropdown-item>
                  </b-dropdown>
                  <input
                    type="hidden"
                    v-validate="'required'"
                    name="cus_id"
                    v-model="field.cus_id"
                    data-vv-name="customer"
                  />
                </div>
                <span v-if="field.cus_id!=''" class="pl-1 mt-2 cursor_pointer">
                  <b-badge variant="success" size="xs">{{field.currency_code}}</b-badge>
                </span>
              </div>
            </b-form-group>
          </b-col>
          <b-col xl="2" lg="2" md="2" sm="2" xs="2" class="text-right">
            <h2 style="margin-bottom:0px"></h2>
          </b-col>
        </b-row>

        <b-row style="max-width:1000px;" class="mt-4">
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group
              label-class="required"
              label="Place of supply"
              label-for="place of supply"
              class="mb-3"
            >
              <v-select
                :clearable="false"
                :disabled="field.place_of_supply=='97'||page == 'update' && (this.list.data.header_details.used_amount>0 ||  this.list.data.header_details.refund_amount > 0) ? true : false"
                id="state-select"
                @input="field.tax_id = ''"
                v-model.trim="field.place_of_supply"
                size="sm"
                index="state_id"
                label="state_name"
                :options="field.buyer_gst_type==6?$AppDetails.state_list:$AppDetails.state_list.filter(x=>x.state_id!='97')"
                v-validate="'required'"
                name="place_supply"
                data-vv-name="place of supply"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group label-class="required" label="Tax" label-for="Select a Tax">
              <template v-if="checkstate()">
                <v-select
                  :clearable="false"
                  @input="checkfortax($event)"
                  :disabled="page == 'update' && (this.list.data.header_details.used_amount>0 || this.list.data.header_details.refund_amount > 0) ? true : false"
                  id="tax-method-select"
                  v-validate="'required'"
                  name="tax_id"
                  v-model.trim="field.tax_id"
                  size="sm"
                  :options="details.local_tax_percent.map(TaxList => ({label:TaxList.label+' ['+parseFloat(TaxList.sales_tax_percent)+'%]', value: TaxList.value,tax_percent:TaxList.sales_tax_percent,tax_ids:TaxList.tax_ids}))"
                />
              </template>
              <template v-else>
                <v-select
                  :clearable="false"
                  @input="checkfortax($event)"
                  :disabled="page == 'update' && (this.list.data.header_details.used_amount>0 ||  this.list.data.header_details.refund_amount > 0) ? true : false"
                  id="tax-method-select"
                  v-validate="'required'"
                  name="tax_id"
                  data-vv-name="tax"
                  v-model.trim="field.tax_id"
                  size="sm"
                  :options="details.igst_tax_percent.map(TaxList => ({label:TaxList.label+' ['+parseFloat(TaxList.sales_tax_percent)+'%]', value: TaxList.value,tax_percent:TaxList.sales_tax_percent,tax_ids:TaxList.tax_ids}))"
                />
              </template>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <b-row style="max-width:1000px;">
        <b-col cols="12" lg="5" md="6" sm="8" v-if="cus_adv_settings_details.cus_adv_code_field">
          <b-form-group
            :label="'Advance'"
            label-class="required"
            label-for="advance-code"
            class="mb-3"
          >
            <b-input-group class="vselect-custom-add">
              <template slot="append">
                <b-input-group-text
                  class="vselect-custom-add-icon"
                  v-b-tooltip
                  title="Customize auto generate code"
                  style="margin-left:2px"
                  v-on:click="$root.$emit('bv::show::modal', 'addautogeneratecode')"
                >
                  <i class="la la-cog"></i>
                </b-input-group-text>
              </template>

              <template slot="prepend">
                <b-form-input
                  style="border-top-right-radius:0 !important;border-bottom-right-radius:0 !important"
                  type="text"
                  size="sm"
                  name="Advance"
                  v-model.trim="field.cus_adv_no"
                  v-validate="'required|max:16'"
                  data-vv-name="advance"
                />
              </template>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group :label="'Reference No.'" label-for="Reference no" class="mb-3">
            <b-form-input
              type="text"
              size="sm"
              name="ref_no"
              v-model.trim="field.ref_no"
              v-validate="'max:30'"
              data-vv-name="reference no"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row style="max-width:1000px;">
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group label-class="required" label="Amount" label-for="Amount" class="mb-3">
            <b-input-group
              :prepend="getDetails($AppDetails.currency_details,field.cus_currency ,'currency_code') || orgCurrency"
              class="mb-2 mr-sm-2 mb-sm-0 payment_currency"
            >
              <b-input
                style="border-radius:0 3px 3px 0 !important"
                :disabled="page == 'update' && (this.list.data.header_details.allow_pymnt == '1' || this.list.data.header_details.used_amount>0 ||  this.list.data.header_details.refund_amount > 0) ? true : false"
                type="text"
                size="sm"
                class="form-control"
                name="pymnt_amount"
                data-vv-name="payment amount"
                @blur="field.pymnt_amount = !isNaN(field.pymnt_amount) && field.pymnt_amount != '' ? parseFloat(field.pymnt_amount).toFixed(2) : parseFloat(0).toFixed(2)"
                v-model.trim="field.pymnt_amount"
                v-validate="'required|excluded:'+parseFloat(0).toFixed(2)+'|min_value:0'"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="5" md="6" sm="8">
          <span v-if="field.is_export == 2" class="d-flex fw-semi-bold">
            <span
              class="mt-3 pt-2"
              v-if=" currency_details.exchange_rate_date!=''||org_details.exchange_rate_status==0"
            >
              <small v-if="changed_currency==false" class="d-block">Exchange rate as on creation,</small>
              <small
                v-else
                class="d-block"
              >As of Date: {{currency_details.exchange_rate_date!=''?getDateFormat(currency_details.exchange_rate_date):getDateFormat(field.pymnt_date)}}</small>
              <span class="float-right" style="font-size:11px;">
                1 {{field.currency_code}} = {{parseFloat(field.unit_currency_value)}} {{orgCurrency}}
                <span>
                  <b-dropdown
                    class="exchange-dropdown"
                    right
                    toggle-class="p-0 text-decoration-none"
                    variant="link"
                    no-caret
                    size="xs"
                    ref="exchange_rate_dropdown"
                  >
                    <template slot="button-content">
                      <i
                        class="la la-edit la-lg theme-text-color pl-1"
                        style="top:-3px;position:relative"
                        @click="exchange_rate_details={ currency_exchange_rate: field.unit_currency_value , save_exchange_rate: 0, recalc: 0 }"
                      ></i>
                    </template>
                    <b-dropdown-header>Edit Exchange Rate</b-dropdown-header>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-form class="p-3" style="width:250px;">
                      <b-row>
                        <b-col>
                          <b-form-group
                            :label="'Exchange Rate(in '+orgCurrency+')'"
                            label-class="required"
                            label-for="ex-rate"
                          >
                            <b-input
                              style="width:130px"
                              @blur="exchange_rate_details.currency_exchange_rate = exchange_rate_details.currency_exchange_rate==''||parseFloat(exchange_rate_details.currency_exchange_rate) <=  0||parseFloat(exchange_rate_details.currency_exchange_rate) >  100000000000000||isNaN(parseFloat(exchange_rate_details.currency_exchange_rate))? 1 : parseFloat(exchange_rate_details.currency_exchange_rate)"
                              v-model="exchange_rate_details.currency_exchange_rate"
                            ></b-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row class="mt-3">
                        <b-col>
                          <b-button variant="primary" size="xs" @click="exchangeRateSubmit()">Save</b-button>
                        </b-col>
                      </b-row>
                    </b-dropdown-form>
                  </b-dropdown>
                </span>
              </span>
            </span>
            <template v-else>
              <b-form-group
                label="Exchange rate"
                label-class="required"
                label-for="currency"
                class="mb-3"
              >
                <b-input-group
                  size="sm"
                  :append="orgCurrency"
                  :prepend="'1 '+getDetails(
                    this.$AppDetails.currency_details,
                    field.cus_currency,
                    'currency_code'
                    ) +' = '"
                >
                  <b-form-input
                    @blur="changeExchangeRate()"
                    type="text"
                    class="text-right"
                    v-model.trim="field.unit_currency_value"
                    name="Currency"
                    data-vv-name="currency"
                    v-validate="'required|decimal:5|excluded:'+parseFloat(0).toFixed(2)+'|min_value:0'"
                  ></b-form-input>
                </b-input-group>
                <small class="text-muted">This will be set as the exchange rate for this date.</small>
              </b-form-group>
            </template>
          </span>
        </b-col>
      </b-row>
      <template v-if="cus_adv_settings_details.custom_field.length > 0">
        <b-row style="max-width:1000px" class="mt-4 mb-2 pt-2">
          <b-col>
            <h6
              class="text-primary pr-2 py-2 fw-semi-bold cursor_pointer h6-lg"
              v-b-toggle.collapse-1
            >
              Custom fields
              <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
            </h6>
          </b-col>
        </b-row>

        <b-collapse id="collapse-1">
          <b-row style="max-width:1000px;">
            <b-col
              cols="12"
              lg="5"
              md="6"
              sm="8"
              :key="index"
              v-for="(custom_field,index) in cus_adv_settings_details.custom_field"
              v-if="custom_field.status == 1 && custom_field.permissions == 'write'"
            >
              <CustomPreview
                v-on:assigncustomvalue="assigncustomvalue($event)"
                :custom="custom_field"
                :disabled="false"
                :modelname="field[custom_field.field_name]"
              />
              <input
                type="hidden"
                :name="custom_field.label_name"
                :data-vv-name="custom_field.label_name"
                v-validate="custom_field.validation"
                v-model="field[custom_field.field_name]"
              />
            </b-col>
          </b-row>
        </b-collapse>
      </template>

      <!--Description for place of supply -->
      <b-form-group class="mt-5 pb-2">
        <b-row style="max-width:700px;">
          <b-col xl="12" lg="12" md="12" sm="12" xs="12">
            <b-form-group>
              <b-row>
                <b-col xl="12" lg="12" md="12" sm="12" xs="12">
                  <label for="datetimepicker">Description</label>
                  <b-form-textarea
                    name="desc_of_supply"
                    rows="4"
                    v-model="field.desc_of_supply"
                    id="desc_of_supply"
                    v-validate="'max:255'"
                    data-vv-name="description"
                  />
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <!--Customer Notes -->
        <b-row style="max-width:700px;" class="pb-3">
          <b-col xl="12" lg="12" md="12" sm="12" xs="12">
            <b-form-group>
              <b-row>
                <b-col xl="12" lg="12" md="12" sm="12" xs="12">
                  <label for="terms_cndtn">Customer Notes</label>
                  <b-form-textarea
                    name="cus_inv_notes"
                    rows="4"
                    id="cus_inv_notes"
                    v-model="field.cus_inv_notes"
                    v-validate="'max:255'"
                    data-vv-name="cus_inv_notes"
                    @input="cus_adv_desc_changed=true"
                  />
                  <b-form-checkbox
                    v-if="cus_adv_desc_changed==true"
                    id="cus_adv_desc_changed"
                    v-model.trim="field.cus_adv_desc_changed"
                    name="cus_adv_desc_changed"
                    value="1"
                    unchecked-value="0"
                  >Use this in future.</b-form-checkbox>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form-group>
      <!--Footer class -->
      <div class="footer">
        <div :class="{'form-action' : true}">
          <b-button
            type="submit"
            :variant="page =='create' ? 'primary' : 'primary'"
            class="btn-rounded mr-3"
            :disabled="submitted"
          >
            <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>
            {{ page =='create' ? 'Save' : 'Update' }}
          </b-button>
        </div>
      </div>
    </b-form>

    <AutoGenerateCode v-on:setCodeValue="getCodeValue($event)" :type="field.type||'customer_advance'"></AutoGenerateCode>
    <!-- Modal for change exchange rate value change warning message -->
    <ExchangeRateWarning></ExchangeRateWarning>
  </div>
</template>
<script scoped>
import CustomPreview from "@/components/Form/Settings/CustomPreview";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead"; // data on search api calls
import { mapState, mapGetters } from "vuex"; // get data set in the state in vuex
import AutoGenerateCode from "@/components/Modal/AutoGenerateCode";
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import vSelect from "vue-select"; // searchable select dropdwon
import DatePicker from "vue2-datepicker"; // vue datepicker
import $ from "jquery"; // for using jquery function
import { formatDate } from "@/mixins/formatDate";
import ExchangeRateWarning from "@/components/Modal/ExchangeRateWarning"; //for Exchange rate change warning message in modal

export default {
  props: ["page", "duplicatecode", "submitted"],
  mixins: [notificationMixin, formatDate], // call the glbal mixin fucntion
  components: {
    AutoGenerateCode,
    VueBootstrapTypeahead, // on change api
    vSelect,
    DatePicker, // datepciker
    CustomPreview,
    ExchangeRateWarning //modal component for exchange rate changes
  },
  data() {
    return {
      search_value: "Customer Name",
      cusadvCollapse: "",
      search_column: "cus_display_name",
      customers: [],
      cus_id: "", // wathc api dropdown data
      update_price: false,
      alertShow: "", // to show the error message
      error_show: false, // to show the error message
      field: this.createFreshEventObject(), // header detail data initialize
      old_cus_id: "",
      old_currency_code: "",
      changed_currency: true,
      exchange_rate_details: {
        currency_exchange_rate: 1,
        save_exchange_rate: 0,
        recalc: 0
      },
      cus_adv_desc_changed: false
    };
  },
  methods: {
     redirectPage(){
       if(this.$route.query.page_from=='view'&&(this.$route.params.id||this.$route.query.old_id)){
              this.$router.push({name:'CustomerAdvanceView',params:{id:this.$route.params.id||this.$route.query.old_id}})
     }
     else {
        if (this.$store.state.customeradvance.customeradvance_index_history) {
          this.$router.push(this.$store.state.customeradvance.customeradvance_index_history);
        } else {
          this.$router.push({ name: "CustomerAdvance" });
        }
      }
     },
    //change exchange rate
    changeExchangeRate() {
      this.old_exchange_rate = this.field.unit_currency_value;
      this.field.unit_currency_value =
        parseFloat(this.field.unit_currency_value) <= 0 ||
        this.field.unit_currency_value == ""
          ? 1
          : this.field.unit_currency_value;
    },
    //  assign custom value
    assigncustomvalue(ev) {
      this.field[ev.field] = ev.value;
    },
    //  update code details
    getCodeValue(ev) {
      this.field.code_id = ev.code_id;
      this.field.suffix = ev.suffix;
      this.field.prefix = ev.prefix;
      this.field.cus_adv_no = ev.prefix + ev.suffix;
    },
    // update tax id and tax percen fields
    checkfortax(ev) {
      if (
        typeof ev.tax_ids != "undefined" &&
        ev.tax_ids != "" &&
        this.update_price == true
      ) {
        this.field.tax_percent = ev.tax_percent;
        this.field.tax_ids = ev.tax_ids;
        var tax_ids = ev.tax_ids.split(",");
        var tax_percent = [];
        for (var i = 0; i < tax_ids.length; i++) {
          tax_percent.push(this.details.tax_main[tax_ids[i]].tax_percent);
        }
        this.field.tax_percents = tax_percent.join(",");
      }
    },
    //  check the place of supply equas organjzation state
    checkstate() {
      var cus_state =
        typeof this.field.place_of_supply != "undefined" &&
        this.field.place_of_supply != null
          ? this.field.place_of_supply
          : 0;
      return cus_state == this.org_details.org_state;
    },
    selectDate(val) {
      this.field.pymnt_date = this.formatDate(val);
      if (this.changed_currency) {
        this.getExchangeRateValue(1);
      }
    },
    // get exchange rate value with transcation date
    getExchangeRateValue(date_change) {
      this.$store
        .dispatch("customer/getCurrencyRate", {
          id: this.field.cus_id,
          currency_id: this.field.cus_currency,
          date: this.field.pymnt_date
        })
        .then(() => {
          this.field.unit_currency_value =
            this.currency_details.currency_exchange_rate != "" &&
            this.currency_details.currency_exchange_rate > 0
              ? this.currency_details.currency_exchange_rate
              : 1;
          this.field.currency_code = this.currency_details.currency_code;
          if (
            this.old_cus_id != this.field.cus_id &&
            this.old_currency_code != this.field.currency_code
          ) {
            this.changed_currency = true;
          } else {
            this.changed_currency = this.page == "update" ? false : true;
          }
        });
    },
    // currency exchange rate dropdown form submit
    exchangeRateSubmit() {
      if (this.exchange_rate_details.save_exchange_rate == 1) {
        var data = {
          currency_id: this.field.cus_currency,
          date: this.field.sales_date,
          value: this.exchange_rate_details.currency_exchange_rate,
          code: this.field.currency_code
        };
        data = JSON.stringify(data);
        this.$store.dispatch("currency/addExchangeRate", data).then(() => {
          this.submitted = false;
          if (this.exchange_rate_type == "success") {
            this.error_msg = false;
            //to show the alert message for success or error after api call
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: this.exchange_rate_message,
              type: this.exchange_rate_type,
              showCloseButton: true
            });
          } else {
            this.error_msg = true;
          }
        });
      }
      this.old_exchange_rate = this.exchange_rate_details.currency_exchange_rate;
      this.field.unit_currency_value = this.exchange_rate_details.currency_exchange_rate;
      // hide dropdown exchange_rate_dropdown
      this.$refs.exchange_rate_dropdown.hide(true);
    },
    checkpos(event) {
      if (this.update_price == true) {
        //  design for selected customer inpout field
        this.customer_details = 0;
        $("#customer_search input").addClass("mask");
        $("#customer_search .input-group").append(
          "<span class='la la-close p-2 mt-1 remover cursor_pointer bg-white'></span>"
        );
        this.field.cus_id = event.value; // assgin the selected customer id to cus id modal
        var cus_state =
          typeof this.field.cus_id != "undefined" &&
          this.field.cus_id != "" &&
          event != null
            ? this.field.cus_id
            : "";
        //  check for foreign currency
        if (cus_state != "" && event.pos != "" && event.pos != null) {
          this.field.place_of_supply = event.pos;
          if (event.currency != this.$AppDetails.organization.org_currency) {
            this.field.is_export = 2;
          } else {
            this.field.is_export = 1;
            this.field.place_of_supply = event.pos;
          }
        }
        this.field.cus_currency = event.currency;
        this.field.buyer_gst_type = event.buyer_gst_type;
        this.getExchangeRateValue(0);
        // var fields = this.field;
        // enter if pos not empty
        // if (cus_state != "") {
        //   $.each(this.$AppDetails.state_list, (key, value) => {
        //     if (value["state_id"] == event.pos) {
        //       fields.place_of_supply = {
        //         label: value["state_name"],
        //         value: value["state_id"]
        //       };
        //     }
        //   });
        // }
      }
    },
    removecustomer(e) {
      if (e.target.matches(".remover")) {
        $("#customer_search input").removeClass("mask");
        $("#customer_search .input-group .remover").remove();
        this.$refs.cus_name_typeahead.inputValue = "";
        this.old_cus_id = this.field.cus_id;
        this.old_currency_code = this.field.currency_code;
        this.old_exchange_rate = this.field.unit_currency_value;
        this.field.buyer_gst_type = "";
        this.field.cus_id = "";
        this.field.place_of_supply = "";
      }
    },
    //onSubmit function
    onSubmit(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          //  send the json data
          var data = JSON.stringify({
            header_details: this.field
          });
          this.$emit("onSubmit", data);
        } else {
          // Scroll to error message show
          var content = $(".container-fluid");
          content[0].scrollIntoView(false);
          this.error_show = true; // validate the form if fail
        }
      });
      return false;
    },
    getIndexValue(arr, prop, val) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = i;

          break;
        }
      }
      return hasMatch;
    },
    createFreshEventObject() {
      // empty details for header
      return {
        type: "customer_advance",
        suffix: "",
        prefix: "",
        code_id: "",
        cus_adv_no: "",
        cus_currency: "",
        currency_code: this.orgCurrency,
        is_export: 1,
        unit_currency_value: 1,
        cus_id: "",
        place_of_supply: "",
        desc_of_supply: "",
        pymnt_amount: "",
        tax_id: "",
        cus_inv_notes: "",
        pymnt_date: this.formatDate(new Date()),
        ref_no: "",
        notes: "",
        tax_ids: "",
        tax_percents: "",
        tax_percent: "",
        buyer_gst_type: ""
      };
    },
    //  customer advance form details
    async updateFields() {
      if (this.page == "update") {
        this.currency_details = {};
        var i;
        for (
          i = 0;
          i < this.cus_adv_settings_details.custom_field.length;
          i++
        ) {
          this.field[
            this.cus_adv_settings_details.custom_field[i].field_name
          ] = this.list.data.header_details[
            this.cus_adv_settings_details.custom_field[i].field_name
          ];
        }
        this.changed_currency = false;
        //  header details
        this.field = this.list.data.header_details;
        this.field.cus_adv_desc_changed = 0;
        this.field.exchange_rate_status = this.org_details.exchange_rate_status;
        this.old_cus_id = this.field.cus_id;
        this.old_currency_code = this.field.currency_code;

        var hasMatch = "";
        if (this.checkstate()) {
          hasMatch = this.getIndexValue(
            this.details.local_tax,
            "value",
            this.list.data.header_details.tax_grp_id
          );
          if (!isNaN(parseInt(hasMatch))) {
            this.details.local_tax[hasMatch].sales_tax_percent = JSON.parse(
              JSON.stringify(this.list.data.header_details.tax_percent)
            );
          }
        } else {
          hasMatch = this.getIndexValue(
            this.details.igst_tax,
            "value",
            this.list.data.header_details.tax_grp_id
          );
          if (!isNaN(parseInt(hasMatch))) {
            this.details.igst_tax[hasMatch].sales_tax_percent = JSON.parse(
              JSON.stringify(this.list.data.header_details.tax_percent)
            );
          }
        }

        //  update tax percent values
        var tax_ids = this.field.tax_ids.split(",");
        var tax_percents = this.field.tax_percents.split(",");
        for (i = 0; i < tax_ids.length; i++) {
          this.details.tax_main[tax_ids[i]].tax_percent = tax_percents[i];
        }

        //  tax fields
        this.field.tax_id = {
          label:
            this.list.data.header_details.tax_name +
            " [" +
            parseFloat(this.list.data.header_details.tax_percent) +
            "%]",
          value: this.list.data.header_details.tax_grp_id
        };

        //  customer details
        this.cus_id = this.list.data.header_details.cus_name;
        //  state details
        this.update_price = await true;
      } else {
        this.update_price = await true;
      }
    }
  },
  // updated: function() {
  //   this.$nextTick(() => {
  //     this.update_price = true;
  //   });
  // },
  watch: {
    cus_id(val) {
      if (val != "" && val.length > 2) {
        var data = {
          search_value: val,
          search_column: this.search_column
        };
        this.$store
          .dispatch("general/fetchCustomerAdvanceSearchData", data)
          .then(() => {
            this.customers = this.customer_filter_list;
          });
      }
    }
  },
  async created() {
    this.field.cus_adv_desc_changed = 0;
    this.field.exchange_rate_status = this.org_details.exchange_rate_status;
    this.field.code_id = this.details.active_code_id.code_id;
    this.field.suffix = this.details.active_code_id.suffix;
    this.field.prefix = this.details.active_code_id.prefix;
    this.field.cus_inv_notes = this.cus_adv_settings_details.cus_inv_notes;
    this.field.cus_adv_no =
      this.details.active_code_id.prefix + this.details.active_code_id.suffix;
    for (
      var i = 0;
      i < this.cus_adv_settings_details.custom_field.length;
      i++
    ) {
      if (
        this.cus_adv_settings_details.custom_field[i].status == 1 &&
        this.cus_adv_settings_details.custom_field[i].permissions == "write"
      ) {
        this.$set(
          this.field,
          this.cus_adv_settings_details.custom_field[i].field_name,
          this.cus_adv_settings_details.custom_field[i].default_value
        );
      }
    }
    await this.updateFields();
    //  to watch any updates in details data
    await this.$watch(
      "field",
      function() {
        this.$emit("FormUpdate");
      },
      {
        deep: true
      }
    );
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      details: state => state.payment.details,
      message: state => state.customeradvance.message,
      customer_filter_list: state => state.general.customer_filter_list,
      list: state => state.customeradvance.list,
      exchange_rate_message: state => state.currency.message,
      exchange_rate_type: state => state.currency.type,
      status_code: state => state.retainer.status_code, 
      status_message: state => state.retainer.status_message, 
      status_type: state => state.retainer.status_type 

    }),
    currency_details: {
      get() {
        return this.$store.state.customer.currency_details;
      },
      set(val) {
        this.$store.state.customer.currency_details = val;
      }
    },
    ...mapGetters(["orgCurrency", "org_details", "cus_adv_settings_details"])
  }
};
</script>
<style scoped>
.create-cus {
  margin-right: 20px !important;
  height: 29px;
  margin-top: 0px !important;
}

.customer_search {
  width: 657px;
}
</style>